import {CFAttrTO} from 'generated/JavaTO'

export function cfAttrTypeIsNumberOrStringComparator(a: CFAttrTO, b: CFAttrTO) {
	const aType = a.type;
	const bType = b.type;

	// null-Werte zuerst
	if (aType == null && bType == null) return 0;
	if (aType == null) return -1;
	if (bType == null) return 1;

	const aNum = +aType;
	const bNum = +bType;
	const aIsNumber = !isNaN(aNum);
	const bIsNumber = !isNaN(bNum);

	// Beide sind gültige Zahlen: numerisch sortieren
	if (aIsNumber && bIsNumber) {
		return aNum - bNum;
	}

	// Nur a ist eine gültige Zahl: a kommt zuerst
	if (aIsNumber && !bIsNumber) {
		return -1;
	}

	// Nur b ist eine gültige Zahl: b kommt zuerst
	if (!aIsNumber && bIsNumber) {
		return 1;
	}

	// Beide sind alphanumerische Strings: alphabetisch sortieren
	return aType.localeCompare(bType);
}